import { AnyAction } from '@reduxjs/toolkit'

import {
  ADD_AUDIT_CONNECTOR_SUCCESS,
  CLEAR_AUDIT_CONNECTOR_SECRET,
  GET_AUDIT_CONNECTOR_SUCCESS,
  REMOVE_AUDIT_CONNECTOR_SUCCESS
} from './actionTypes'

export type OrganizationAuditConnectorPageState = {
  auditConnectors: { id: string; clientCredential: { clientSecret?: string } }[]
}

export const initialState: OrganizationAuditConnectorPageState = { auditConnectors: [] }

export default function apiConnectorReducer(
  state = initialState,
  action: AnyAction
): OrganizationAuditConnectorPageState {
  switch (action.type) {
    case ADD_AUDIT_CONNECTOR_SUCCESS: {
      return {
        ...state,
        auditConnectors: [...state.auditConnectors, action.response]
      }
    }
    case GET_AUDIT_CONNECTOR_SUCCESS: {
      return {
        ...state,
        auditConnectors: [...state.auditConnectors, ...action.response]
      }
    }
    case REMOVE_AUDIT_CONNECTOR_SUCCESS: {
      return {
        ...state,
        auditConnectors: state.auditConnectors.filter(auditConnector => auditConnector.id !== action.auditConnectorId)
      }
    }
    case CLEAR_AUDIT_CONNECTOR_SECRET: {
      return {
        ...state,
        auditConnectors: state.auditConnectors.map(auditConnector => {
          if (auditConnector.id === action.auditConnectorId) {
            delete auditConnector.clientCredential.clientSecret
          }

          return auditConnector
        })
      }
    }
    default: {
      return state
    }
  }
}
